
export const toLowercaseTrim = (inputString?: string) =>
  (inputString ?? ``).trim().toLowerCase();

export const capitalizeFirstLetter = (inputString: string) =>
  `${inputString.charAt(0).toUpperCase()}${inputString.slice(1)}`;

export const stringContainsTerm = (needle?: string, haystack?: string, isCaseSensitive?: boolean) => {
  if (!needle || !haystack) {
    return false;
  }

  const formattedNeedle = isCaseSensitive ? needle : needle.toLowerCase();
  const formattedHaystack = isCaseSensitive ? haystack : haystack.toLowerCase();

  return formattedHaystack.includes(formattedNeedle);
}

export const trimRight = (inputString: string, characterToRemove : string = " ") =>
{
  let workingCopy = inputString;

  if (characterToRemove.length > 0) {
    while (workingCopy.endsWith(characterToRemove)) {
      workingCopy = workingCopy.slice(0, -1);
    }
  }

  return workingCopy;
}

export const createGuid = (): string => {
  function create4CharacterString() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  const result = create4CharacterString() + create4CharacterString()
    + '-' + create4CharacterString()
    + '-' + '4' + create4CharacterString().substr(0, 3)
    + '-' + create4CharacterString()
    + '-' + create4CharacterString() + create4CharacterString() + create4CharacterString();
  return result;
}

export function getLoremIpsumText(length?: number) {
  const loremIpsum = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum vel fermentum est. Aliquam cursus dolor in semper accumsan. Etiam tincidunt iaculis mi, sed consequat erat. Mauris dapibus eleifend cursus. Vivamus magna diam, mattis ut lacus pellentesque, imperdiet congue enim. Fusce rhoncus ipsum vel risus dapibus, eu dignissim leo consequat. Sed non tortor magna. In hac habitasse platea dictumst."

    + "Quisque convallis elit a nunc venenatis vulputate. Curabitur velit neque, molestie non sem sit amet, condimentum semper ex. Curabitur blandit risus eu tincidunt blandit. Nulla risus sem, euismod vitae enim nec, scelerisque ultricies elit. Nam bibendum, dolor in ullamcorper tincidunt, libero nulla consectetur leo, vitae luctus neque nibh eget elit. Praesent dapibus tempor ex, eget lobortis ante maximus vulputate. Aliquam sed quam in lorem viverra blandit. Nunc lobortis rutrum est, sed feugiat velit aliquet in. Praesent sit amet mauris faucibus, mattis ex at, scelerisque nibh."

    + "Praesent sed ullamcorper ligula. Mauris tincidunt, ante in facilisis euismod, sem libero pharetra sem, id laoreet arcu sapien ac lectus. Nunc pulvinar pharetra bibendum. Nullam consectetur a sapien vitae efficitur. Suspendisse sagittis justo eu turpis posuere luctus. Morbi vel risus at orci pretium porta. Pellentesque ut volutpat ligula, eu tristique arcu. Mauris facilisis at magna vel sagittis. Donec scelerisque libero et massa rutrum molestie. Interdum et malesuada fames ac ante ipsum primis in faucibus. Quisque non maximus tellus, in iaculis lorem. Quisque quam urna, eleifend porta fermentum quis, dictum sed urna. Aliquam erat volutpat."

    + "Aliquam et justo ut nulla malesuada viverra. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Nulla condimentum placerat risus, sit amet tincidunt mauris fringilla vitae. Nam varius, enim vitae interdum blandit, neque lectus semper sapien, id varius velit ex tincidunt tortor. Duis nec interdum risus. Aenean suscipit placerat tortor, eu dictum nisi scelerisque a. Ut vehicula ex dui, ac condimentum lorem tristique a. Nam vel lobortis est, bibendum euismod eros. Aenean tincidunt condimentum nibh vel varius. Proin rutrum erat vitae interdum vehicula. Vestibulum quam lorem, dignissim eget tincidunt sit amet, mattis at urna. Quisque bibendum lorem felis, vel luctus arcu consectetur sit amet. Nulla facilisis bibendum nisi, non volutpat justo iaculis quis. Donec ac lectus a eros varius cursus nec blandit erat. Cras vel posuere risus. Nam sit amet viverra velit."

    + "Nulla tincidunt interdum libero, ut scelerisque orci gravida ut. Suspendisse elementum leo sed nisl dictum egestas. Vivamus non sapien at lacus ullamcorper eleifend ut vitae ligula. Donec elementum purus non felis tincidunt ornare. Sed convallis enim tellus, nec elementum diam consequat eget. Fusce gravida sapien quis est malesuada faucibus. Maecenas sed diam non lectus tempus pellentesque. Duis gravida elit neque, id euismod dui dictum quis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer lobortis, nibh et laoreet pharetra, dolor libero pretium nunc, vitae molestie libero mauris vitae erat. Suspendisse ac pharetra est, in tincidunt dui. Praesent commodo rhoncus gravida. Donec dapibus, arcu vitae sollicitudin feugiat, arcu eros molestie justo, quis accumsan tellus mauris non risus. Curabitur nec nunc ac nisl mattis iaculis.";

  if (length) {
    return loremIpsum.substring(0, Math.min(length, loremIpsum.length));
  }

  return loremIpsum;
}

